import { useV2ListTeamsForAccountQuery } from "@generated";

interface Team {
  label: string;
  value: string;
  users: string[];
}

const useListTeamsForAccount = () => {
  let customError: string | null = null; // Declare customError

  const { data, error, isLoading, refetch, isFetching } =
    useV2ListTeamsForAccountQuery({
      include: ["users"],
    });

  let teams: Team[] = [];

  if (data?.data) {
    try {
      teams = data.data.map((team) => {
        if (!team.id) {
          throw new Error("Missing team.id");
        }
        if (!team.attributes?.name) {
          throw new Error("Missing team.attributes.name");
        }

        return {
          value: String(team.id),
          label: team.attributes.name || "",
          users:
            team.relationships?.users?.data?.map((user) => String(user.id)) ||
            [],
        };
      });
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }
  return {
    teams,
    isLoading,
    error: error ?? customError,
    refetch,
    isFetching,
  };
};
export default useListTeamsForAccount;
